import { Component, Inject, OnInit } from "@angular/core"
import { MD_DIALOG_DATA, MdDialog, MdDialogRef } from "@angular/material"

import { Merchant } from "../../../shared/merchant"
import { MerchantReferralCampaignPagesColors } from "../../../shared/merchant-referral"
import { ToolService } from "../../../tool.service"
import { AdvocateInfo } from "../../advocate-info"
import { ReferralService } from "../../referral.service"
import { ReferralMagicEmailModalComponent } from "../email-modal/email-modal.component"
import { ModalData } from "../modal-data"

@Component({
  selector: "app-success-modal",
  templateUrl: "./success-modal.component.html",
  styleUrls: ["./success-modal.component.scss"],
  providers: [ReferralService, ToolService]
})
export class ReferralMagicSuccessModalComponent implements OnInit {
  // Local variables
  advocate_info: AdvocateInfo
  advocate_identifier: string
  advocate_url: string
  colors: MerchantReferralCampaignPagesColors
  is_embedded: boolean
  merchant: Merchant
  qualification: string

  constructor(
    private referralService: ReferralService,
    private mdDialog: MdDialog,
    private mdDialogRef: MdDialogRef<ReferralMagicSuccessModalComponent>,
    @Inject(MD_DIALOG_DATA) public data: ModalData
  ) {
    this.advocate_info = data.advocate_info
    this.advocate_identifier = data.advocate_identifier
    this.advocate_url = data.advocate_url
    this.colors = data.colors
    this.is_embedded = data.is_embedded
    this.merchant = data.merchant
    this.qualification = data.qualification
  }

  ngOnInit() {}

  openFacebookUrl() {
    const facebook_advocate_url = `${this.advocate_url}?ref=facebook`
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(facebook_advocate_url)}`, "_blank")
    this.mdDialogRef.close(true)
  }

  openEmailDialog() {
    if (this.qualification === "all") {
      return window.open(`mailto:${this.advocate_url}?ref=email`)
    }

    const modalClosedSubscription = this.mdDialogRef.afterClosed().subscribe(() => {
      this.mdDialog.open(ReferralMagicEmailModalComponent, {
        data: {
          advocate_info: this.advocate_info,
          advocate_url: this.advocate_url,
          advocate_identifier: this.advocate_identifier,
          colors: this.colors,
          merchant: this.merchant,
          referralService: this.referralService,
          qualification: this.qualification
        }
      })
      modalClosedSubscription.unsubscribe()
    })
    this.mdDialogRef.close(true)
  }
}



// WEBPACK FOOTER //
// /home/runner/work/onelocal/onelocal/src/my-referral/src/app/referral-magic/merchant-advocate/success-modal/success-modal.component.ts